import { AppLocation } from 'src/navigation/appLocations'
import * as Routes from 'src/navigation/urls'

// Family route tree — single source for paths, metadata, and tab descriptors (src/navigation/AGENTS.md).

export interface PeopleFamilyTabNode {
  /** Stable key used for active-tab detection and FamilyLayout. */
  key: string
  /** Translation key; resolved via `translate()` (useTranslate) in the page. */
  labelSource: string
  /** AppLocation that drives sidenav active state via locationHooks. */
  appLocation: AppLocation
  /** Exact URL pattern, e.g. `/people/members`. */
  path: string
}

export const peopleRouteTree = {
  family: {
    /** `/people` — redirects to the first tab. */
    rootPath: Routes.peopleUrl(),
    rootAppLocation: AppLocation.People,
    redirectTo: Routes.peopleMembersUrl(),
    tabs: [
      {
        key: 'members',
        labelSource: 'Organization Members',
        appLocation: AppLocation.PeopleMembers,
        path: Routes.peopleMembersUrl(),
      },
      {
        key: 'invited',
        labelSource: 'Invited To Org',
        appLocation: AppLocation.PeopleInvitedToOrg,
        path: Routes.peopleInvitedToOrgUrl(),
      },
    ] as PeopleFamilyTabNode[],
  },
}

/**
 * Family root + every static tab path, then a render-only catch-all so unknown
 * children (`/people/typo`) keep the People-scoped not-found the legacy
 * `exact:false` shell served rather than falling to the global 404. Static
 * paths precede it, so they still win the match.
 *
 * The catch-all is safe here because this gate feeds the BACKGROUND <Switch>
 * and every People overlay URL (`/people/members/:id`, `/people/invited/:id`,
 * `/people/invited/cancel/:id`) has a `modalBackgrounds` entry remapping its
 * background pathname onto a static tab path above — so the catch-all cannot
 * capture an overlay. A family without that coverage must not copy this.
 *
 * Render-only: it carries no AppLocation and stays out of
 * `flatArchitectureRouteMetadata` (src/navigation/AGENTS.md).
 */
export const peopleFamilyGatePaths: string[] = [
  peopleRouteTree.family.rootPath,
  ...peopleRouteTree.family.tabs.map((t) => t.path),
  `${peopleRouteTree.family.rootPath}/:rest+`,
]
